<ion-list lines="none">
  <ion-item>
    <ion-icon src="/assets/icons/32px/recordings-bold.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Why Microphones Matter</h3>
      </ion-text>

      <ion-text color="black">
        <p>Listeners value Quality audio and relate it to your Credibility</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/distance-from-microphone-3.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Proper Microphone Technique</h3>
      </ion-text>

      <ion-text color="black">
        <p>Record with the Microphone placed a fist distance from your mouth</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item *ngIf="osMicrophoneSelection">
    <ion-icon src="/assets/icons/24px/microphone.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>OS Microphone Selection</h3>
      </ion-text>

      <ion-text color="black">
        <p>
          {{ osMicrophoneSelection }}
        </p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item>
    <ion-icon src="/assets/icons/24px/lock.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>Browser Permissions</h3>
      </ion-text>

      <ion-text color="black">
        <p>Allow Browser permission by clicking on the Lock icon to the left of the URL</p>
      </ion-text>
    </ion-label>
  </ion-item>

  <ion-item *ngIf="osSecurityPreferences">
    <ion-icon src="/assets/icons/24px/lock.svg" slot="start" color="darker"> </ion-icon>

    <ion-label class="ion-text-wrap">
      <ion-text color="darker">
        <h3>OS Permissions</h3>
      </ion-text>

      <ion-text color="black">
        <p>
          {{ osSecurityPreferences }}
        </p>
      </ion-text>
    </ion-label>
  </ion-item>
</ion-list>
